<div class="content_header">
  <mat-icon color="primary">grid_view</mat-icon>
  <mat-label>{{ 'aplicaciones' | translate }}</mat-label>
</div>

<div mat-dialog-content>
  @if (listApps.length === 0) {
    <div class="container-without-results">
      <p>{{ 'sin-resultados' | translate }}</p>
    </div>
  }

  @if (listApps.length > 0) {
    <mat-grid-list cols="3" rowHeight="120px">
      @for (app of listApps; track app) {
        <mat-grid-tile (click)="goToLink(app.pageUrl)" matRipple>
          <img class="logo" [src]="app.urlImg" />
          <span [class]="app.className">{{ app.name | translate }}</span>
        </mat-grid-tile>
      }
    </mat-grid-list>
  }
</div>

<div mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close>{{ 'cerrar' | translate }}</button>
</div>
